import { FC, memo } from 'react'

import { Button, Stack, Typography, useTheme } from '@mui/material'
import { CreateNewFolder, NoteAdd } from '@mui/icons-material'

import { useTranslation } from 'react-i18next'

import useModal from 'src/hooks/useModal'

import { MentorCloudCreateFolderModal } from '../MentorCloudCreateFolderModal/MentorCloudCreateFolderModal'

import { Folder } from 'src/types/files/file'

interface MentorCloudHeaderProps {
  onClickUpload?: () => void
  parentFolderId?: number | null
  parentFolder?: Folder | null
}

export const MentorCloudHeader: FC<MentorCloudHeaderProps> = memo(props => {
  const { onClickUpload, parentFolder, parentFolderId } = props

  const theme = useTheme()
  const { t } = useTranslation('translation', { keyPrefix: 'PAGE.MENTORCLOUD' })

  const { isOpen, close, open } = useModal()

  return (
    <Stack
      gap={theme.spacing(2)}
      alignItems={'center'}
      sx={{
        flexDirection: { xs: 'column', md: 'row' }
      }}
      justifyContent={'space-between'}
    >
      <Typography variant='h4'>{parentFolder?.name || t('home')}</Typography>
      <Stack width={{ xs: '100%', md: 'auto' }} gap={theme.spacing(2)} flexDirection={{ xs: 'column', md: 'row' }}>
        <Button fullWidth variant='outlined' endIcon={<NoteAdd />} onClick={onClickUpload}>
          {t('header.upload_file')}
        </Button>
        <Button fullWidth onClick={open} variant='outlined' endIcon={<CreateNewFolder />}>
          {t('header.create_folder')}
        </Button>
      </Stack>
      <MentorCloudCreateFolderModal parentFolderId={parentFolderId} isOpen={isOpen} onClose={close} />
    </Stack>
  )
})
